import * as React from 'react';

interface IRootProps {
};

const Root: React.SFC<IRootProps> = ({children}) => {
  return (
    <div style={{height: "100%", position: "relative", width: "100%"}}>
        {children}
    </div>
  );
};

export default Root;